import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=f1b4a3f8&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=f1b4a3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b4a3f8",
  null
  
)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseInput', component.exports)
}
export default component.exports